import logo from './logo.svg';
import './App.css';
import  ReactBuild  from "./Components/ReactBuild";

function App() {
  return (
    <div className="App">
    <ReactBuild/>
    </div>
  );
}

export default App;
